import { Typography } from '@mui/material'
import MainRouter from 'MainRouter'
import NoClientRouter from 'NoClientRouter'
import useAuth from 'hooks/useAuth/useAuth'
import useFetchGlobalSetting from 'hooks/useFetchGlobalSetting/useFetchGlobalSetting'
import useTableLayoutDisplay from 'hooks/useTableLayoutDisplay/useTableLayoutDisplay'
import { ClientType } from 'models'
import { useEffect } from 'react'
import { Subscription } from 'rxjs'
import { useAppSelector } from 'store/useStoreHook'
import posEvent, { POSEventType } from 'websockets/events/posHubEvent'

function RouterPortal() {
    useFetchGlobalSetting()
    const { refetchTableLayouts } = useTableLayoutDisplay()
    const { isAuthenticated } = useAuth()

    const client = useAppSelector((state) => state.client.currentClient)

    // define logic need to load once when app started after pass authorization here
    useEffect(() => {
        let subscription: Subscription | null = null

        if (isAuthenticated) {
            refetchTableLayouts()

            // register handler on posHub Event that needs authentication as prerequisite
            subscription = posEvent.subscribe((event) => {
                if (event.type === POSEventType.OnTableLayoutChanged) {
                    // update table layout cache
                    refetchTableLayouts()
                }
            })
        }

        return () => {
            subscription?.unsubscribe()
        }
    }, [isAuthenticated, refetchTableLayouts])

    if (client === null || client === undefined) return <NoClientRouter />

    return client?.type === ClientType.PosTerminalWithCash ||
        client?.type === ClientType.PosTerminalWithOutCash ||
        client?.type === ClientType.OrderQuesTerminal ? (
        <MainRouter />
    ) : (
        <Typography>No defined router for {client?.type}</Typography>
    )
}

export default RouterPortal
